import { z } from 'zod/v4';

export enum Packaging {
    AmmoPack = 'AmmoPack',
    Bag = 'Bag',
    Bulk = 'Bulk',
    Carton = 'Carton',
    Reel = 'Reel',
    ReReel = 'ReReel',
    Spool = 'Spool',
    Tape = 'Tape',
    Tray = 'Tray',
    Tube = 'Tube',
}
export const PackagingRuntype = z.enum(Packaging);

export enum PackagingWithUnknown {
    AmmoPack = 'AmmoPack',
    Bag = 'Bag',
    Bulk = 'Bulk',
    Carton = 'Carton',
    Reel = 'Reel',
    ReReel = 'ReReel',
    Spool = 'Spool',
    Tape = 'Tape',
    Tray = 'Tray',
    Tube = 'Tube',
    Unknown = 'Unknown',
}
export const PackagingWithUnknownRuntype = z.enum(PackagingWithUnknown);

export function toPackaging(value: PackagingWithUnknown): Packaging | undefined {
    switch (value) {
        case PackagingWithUnknown.AmmoPack:
            return Packaging.AmmoPack;
        case PackagingWithUnknown.Bag:
            return Packaging.Bag;
        case PackagingWithUnknown.Bulk:
            return Packaging.Bulk;
        case PackagingWithUnknown.Carton:
            return Packaging.Carton;
        case PackagingWithUnknown.Reel:
            return Packaging.Reel;
        case PackagingWithUnknown.ReReel:
            return Packaging.ReReel;
        case PackagingWithUnknown.Spool:
            return Packaging.Spool;
        case PackagingWithUnknown.Tape:
            return Packaging.Tape;
        case PackagingWithUnknown.Tray:
            return Packaging.Tray;
        case PackagingWithUnknown.Tube:
            return Packaging.Tube;
        case PackagingWithUnknown.Unknown:
            return undefined;
    }
}
